(function () {
  function showBlockingPopup(distributor) {
    var popup = document.getElementById('DistributorPopup');
    if (popup && typeof popup.forceShow === 'function') {
      popup.forceShow(distributor);
      return;
    }

    console.warn(
      'Distributor popup element not found (the "Distributor popup" section may be disabled in the theme editor). Falling back to alert().'
    );
    var countryName = distributor.country_name || distributor.country;
    var isPolish = (document.documentElement.lang || '').toLowerCase().indexOf('pl') === 0;

    window.alert(
      isPolish
        ? 'Nie prowadzimy sprzedaży bezpośredniej w ' + countryName +
          '. Zamówienie możesz złożyć u naszego lokalnego dystrybutora: ' + distributor.company_name + ' (' + distributor.distributor_url + ')'
        : 'We do not offer direct sales in ' + countryName +
          '. You can place your order with our local distributor: ' + distributor.company_name + ' (' + distributor.distributor_url + ')'
    );
  }

  function shouldBlock() {
    if (!window.DistributorTheme) return null;

    // Production access rules apply independently of the theme editor debug mode.
    var distributor = window.DistributorTheme.getDistributor();
    if (!distributor) return null;
    if (window.DistributorTheme.isExemptBuyer(distributor)) return null;

    return distributor;
  }

  document.addEventListener(
    'submit',
    function (event) {
      if (!event.target.closest('form[is="product-form"]')) return;

      var distributor = shouldBlock();
      if (!distributor) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      showBlockingPopup(distributor);
    },
    { capture: true }
  );

  document.addEventListener(
    'click',
    function (event) {
      if (!event.target.closest('[data-product-bundle-submit]')) return;

      var distributor = shouldBlock();
      if (!distributor) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      showBlockingPopup(distributor);
    },
    { capture: true }
  );
})();
